module.exports = __webpack_public_path__ + "static/media/logo-saude.6e830f7c.png";